module.exports = "/assets/3c2b2f9d20d75731ce097f418ba1ae77.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ukrail/mobileappurl_qrcode.png
// module id = 712
// module chunks = 0